define('presentation/signup/viewModels/signupPlansTelephonyViewModel',[
    'businessServices/signup/signupSessionStore',
    'common/promises/promiseFactory',
    'constants/billingPackageTypeConstants',
    'i18next',
], function () {
    return function () {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _billingPackageTypes = require('constants/billingPackageTypeConstants');
        const _i18n = require('i18next');

        const HOSTED_NUMBERS_AFFILIATE_CODE = "HNC";

        let _signupSessionStore = null;

        self.isNavigateToNextPageActive = ko.observable(true);
        self.isNavigateToNextPageVisible = ko.observable(true);

        self.packagePickerPackageType = ko.observable(null);
        self.packagePickerPackageId = ko.observable(null);
        self.packagePickerAvailablePackages = ko.observableArray([]);

        self.isHostedNumbersAffiliate = ko.observable(false);

        self.headingText = ko.pureComputed(() => {
            return self.isHostedNumbersAffiliate() ? _i18n.t('signupPlans:hostedNumbersTitle') : '';
        });

        self.subtitleText = ko.pureComputed(() => {
            return self.isHostedNumbersAffiliate() ? _i18n.t('signupPlans:hostedNumbersMessage') : '';
        });

        self.onForwardArrowClicked = null;
        self.onBackArrowClicked = null;

        self.onPackagePickerSelect = () => {};
        self.onLargerPlanSelect = () => {};

        self.activate = ({ telephonyPackage, selectedPackageId, affiliateId, onPackageSelected, onForwardArrowClicked, onBackArrowClicked }) => {
            const SignupSessionStoreConstructor = require('businessServices/signup/signupSessionStore');
            _signupSessionStore = new SignupSessionStoreConstructor();
            _signupSessionStore.init();

            self.onForwardArrowClicked = onForwardArrowClicked;
            self.onBackArrowClicked = onBackArrowClicked;

            self.isHostedNumbersAffiliate(affiliateId === HOSTED_NUMBERS_AFFILIATE_CODE);

            self.packagePickerPackageType(_billingPackageTypes.telephony.id);
            self.packagePickerPackageId(selectedPackageId || null);
            self.packagePickerAvailablePackages(telephonyPackage ? [telephonyPackage] : []);

            _signupSessionStore.savePackageTypeSelection(_billingPackageTypes.telephony.id);

            if (telephonyPackage && onPackageSelected) {
                _promiseFactory.defer((savePromise) => {
                    onPackageSelected(telephonyPackage)
                        .fail(savePromise.reject)
                        .done(() => savePromise.resolve());
                });
            }

            return _promiseFactory.wait();
        };
    };
});
